import { LanguagePair } from 'components-legacy';
import Link from 'next/link';
import { FC } from 'react';
import { PurchaseOrderUnitary } from '../_context/useTableOrders';

interface ILanguagePairsOrder {
  purchaseOrder: PurchaseOrderUnitary;
}

const LanguagePairsOrder: FC<ILanguagePairsOrder> = ({ purchaseOrder }) => (
  <Link
    href={`/translation/show-translation/${purchaseOrder.order.translationRequest?.version}`}
    target="_blank"
    className="!font-normal"
  >
    <LanguagePair
      sourceLanguageCode={purchaseOrder.order.translationRequest?.sourceLanguageCode ?? ''}
      targetLanguageCode={purchaseOrder.order.translationRequest?.targetLanguageCode ?? ''}
    />
  </Link>
);

export default LanguagePairsOrder;
